import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PrintErrorComponent } from "./component/print-error.component";

@NgModule({
    declarations: [PrintErrorComponent],
    imports: [CommonModule],
    exports: [PrintErrorComponent],
})
export class PrintErrorModule {}
